import { Controller } from "@hotwired/stimulus"
import { fixedTooltipPosition, tooltipGroupClasses } from "../src/fixed_tooltip_position.js"

// Podpowiedzi w przewijanym kontenerze (np. kolumnie kanbanu) - span z `group-hover:block` wewnątrz
// elementu `.group` - były ucinane na krawędzi kontenera (overflow przycina absolute). Na czas
// najechania przełączamy podpowiedź na position: fixed i liczymy jej miejsce względem elementu;
// fixed nie jest przycinany przez overflow przodków. Znaczniki podpowiedzi zostają bez zmian.
//
// Użycie: data-controller="fixed-tooltip" na kontenerze z podpowiedziami. Przy nazwanej grupie
// (group/<nazwa> + group-hover/<nazwa>:block) dodaj data-fixed-tooltip-group-value="<nazwa>".
export default class extends Controller {
  static values = { group: String }

  connect() {
    this.groupClasses = tooltipGroupClasses(this.groupValue)
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.reset = this.reset.bind(this)
    this.position = this.position.bind(this)
    this.element.addEventListener("mouseover", this.show)
    this.element.addEventListener("mouseout", this.hide)
    // przewinięcie kolumny przesuwa element spod podpowiedzi - wracamy do zwykłego ułożenia
    this.element.addEventListener("scroll", this.reset, true)
    // przewinięcie strony też go przesuwa - podpowiedź (fixed) liczymy na nowo, żeby szła za nim
    window.addEventListener("scroll", this.position, { capture: true, passive: true })
  }

  disconnect() {
    this.element.removeEventListener("mouseover", this.show)
    this.element.removeEventListener("mouseout", this.hide)
    this.element.removeEventListener("scroll", this.reset, true)
    window.removeEventListener("scroll", this.position, { capture: true })
    this.reset()
  }

  show(event) {
    const trigger = event.target.closest(`.${CSS.escape(this.groupClasses.group)}`)
    if (!trigger || trigger === this.trigger || !this.element.contains(trigger)) return

    const tip = [...trigger.children].find((child) => child.classList.contains(this.groupClasses.tip))
    if (!tip) return

    this.reset()
    this.trigger = trigger
    this.tip = tip
    this.originalStyle = tip.getAttribute("style")
    Object.assign(tip.style, {
      position: "fixed", top: "0px", left: "0px", right: "auto", bottom: "auto", margin: "0", translate: "none",
    })

    this.position()
  }

  // podpowiedź jest już widoczna (group-hover), więc da się ją zmierzyć
  position() {
    if (!this.tip) return

    const box = fixedTooltipPosition(
      this.trigger.getBoundingClientRect(),
      { width: this.tip.offsetWidth, height: this.tip.offsetHeight },
      { width: window.innerWidth, height: window.innerHeight },
    )
    this.tip.style.left = `${box.left}px`
    this.tip.style.top = `${box.top}px`
  }

  hide(event) {
    // mouseout leci też przy przejściu między dziećmi elementu - chowamy dopiero po wyjściu z niego
    if (!this.trigger || this.trigger.contains(event.relatedTarget)) return

    this.reset()
  }

  reset() {
    if (!this.tip) return

    if (this.originalStyle === null) {
      this.tip.removeAttribute("style")
    } else {
      this.tip.setAttribute("style", this.originalStyle)
    }
    this.tip = null
    this.trigger = null
  }
}
